import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import { useLanguage } from '../context/LanguageContext';

const getApiUrl = () => {
  const hostname = window.location.hostname.toLowerCase();
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('localhost');
  return isLocalhost ? 'http://localhost:5000' : 'https://orders.fletaime.com';
};

const WHATSAPP_PHONE = '38345937644';

export default function OrderSuccess() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order');
  const [order, setOrder] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!orderId) {
      setChecking(false);
      return;
    }

    let cancelled = false;
    const API_URL = getApiUrl();

    // The order is marked "paid" by Stripe's webhook, which can land a
    // second or two after the customer is redirected here - poll briefly
    // instead of trusting the redirect itself as proof of payment.
    const checkStatus = async (attempt) => {
      try {
        const res = await fetch(`${API_URL}/order-info/${orderId}`);
        const data = await res.json();
        if (cancelled) return;
        setOrder(data.order || null);
        if (data.order?.payment_status === 'paid' || attempt >= 3) {
          setChecking(false);
          return;
        }
        setTimeout(() => checkStatus(attempt + 1), 1500);
      } catch {
        if (!cancelled) setChecking(false);
      }
    };

    checkStatus(1);
    return () => { cancelled = true; };
  }, [orderId]);

  const confirmed = order?.payment_status === 'paid';

  const sendWhatsappConfirmation = () => {
    const message =
      `${t('wa.success.title')}\n\n` +
      `${t('wa.success.paidLine', { id: orderId })}\n` +
      (order ? `${t('wa.success.name')} ${order.name || ''} ${order.last_name || ''}\n${t('wa.success.product')} ${order.product_name || ''}\n${t('wa.success.price')} ${order.amount_paid || order.price || ''}€\n` : '') +
      `\n${t('wa.success.wantConfirm')}`;
    const url = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(message)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="order-form-page">
      <Header />
      <div style={{ maxWidth: '560px', margin: '60px auto', padding: '32px 24px', textAlign: 'center' }}>
        <div style={{ fontSize: '56px', marginBottom: '16px' }}>{checking ? '⏳' : confirmed ? '✅' : '📦'}</div>
        <h1 style={{ marginBottom: '12px' }}>
          {checking ? t('success.checking') : confirmed ? t('success.confirmed') : t('success.thanks')}
        </h1>
        <p style={{ color: '#555', marginBottom: '24px' }}>
          {confirmed
            ? t('success.confirmedDesc', { id: orderId })
            : t('success.pendingDesc', { id: orderId })}
        </p>

        <button
          onClick={sendWhatsappConfirmation}
          style={{
            display: 'inline-block',
            background: '#25D366',
            color: 'white',
            border: 'none',
            padding: '14px 28px',
            borderRadius: '8px',
            fontWeight: 'bold',
            fontSize: '15px',
            cursor: 'pointer',
            marginBottom: '16px',
          }}
        >
          {t('success.sendConfirmBtn')}
        </button>

        <div>
          <Link to="/" style={{ color: '#2d3748', textDecoration: 'underline' }}>{t('success.backHome')}</Link>
        </div>
      </div>
    </div>
  );
}
